<!-- ABA INFORMAÇÕES BÁSICAS -->
<form [formGroup]="form" #f="ngForm">
  <div class="card-body">

    <div class="row">

      <div class="form-group col-md-2">
        <label for="numeroOsa" class="mb-1">Número da OSA</label>
        <input disabled type="text" id="numeroOsa" class="form-control form-control-sm" [ngModel]="model?.osa?.numeroOrigem"
          [ngModelOptions]="{standalone: true}" />
      </div>

      <div class="form-group col-md-2">
        <label for="numeroOpa" class="mb-1">Número da OPA</label>
        <input disabled type="text" id="numeroOpa" class="form-control form-control-sm"
          [ngModel]="model?.osa?.planejamento?.opa?.numero" [ngModelOptions]="{standalone: true}" />
      </div>

      <div class="form-group col-md-2">
        <label for="origemAuditoria" class="mb-1">Origem de Auditoria</label>
        <input disabled type="text" id="origemAuditoria" class="form-control form-control-sm"
          [ngModel]="model?.osa?.planejamento?.opa?.origem?.descricao" [ngModelOptions]="{standalone: true}" />
      </div>

      <div class="form-group col-md-3">
        <label for="dataElaboracao" class="mb-1">Data de Elaboração</label>
        <input disabled type="text" id="dataElaboracao" class="form-control form-control-sm"
          [ngModel]="model?.dataElaboracao | date: 'dd/MM/yyyy'" [ngModelOptions]="{standalone: true}" />
      </div>

      <div class="form-group col-md-3">
        <label for="tipoAuditoria" class="mb-1">Tipo da Auditoria</label>
        <input disabled type="text" id="tipoAuditoria" class="form-control form-control-sm"
          [ngModel]="model?.osa?.planejamento?.opa?.tipoAuditoria?.nome" [ngModelOptions]="{standalone: true}" />
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label class="mb-1">Unidade Gestora a ser Auditada</label>
        <input type="text" [readonly]="true" class="form-control form-control-sm"
          [value]="model?.osa?.unidadeGestora?.nome" />
      </div>

      <div class="form-group col-md-3">
        <label for="dataInicioPrevista" class="mb-1">Data Prevista Início da Auditoria</label>
        <input type="text" id="dataInicioPrevista" class="form-control form-control-sm"
          [value]="model?.osa?.planejamento?.opa?.dataInicioPrevista | date: 'dd/MM/yyyy'" disabled />
      </div>

      <div class="form-group col-md-3">
        <label for="dataFimPrevista" class="mb-1">Data Prevista Fim da Auditoria</label>
        <input type="text" id="dataFimPrevista" class="form-control form-control-sm"
          [value]="model?.osa?.planejamento?.opa?.dataFimPrevista | date: 'dd/MM/yyyy'" disabled />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="objeto" class="mb-1">Objeto</label>
        <textarea readonly style="resize: none" rows="4" class="form-control form-control-sm"
          [value]="model?.osa?.planejamento?.opa?.objeto"></textarea>
      </div>
    </div>

    <div class="row">

      <div class="form-group col-md-2">
        <label for="periodoAuditado" class="mb-1">Período a ser <br> Auditado</label>
        <input type="text" disabled id="periodoAuditado" class="form-control form-control-sm"
          [value]="model?.osa?.periodoAuditado" />
      </div>

      <div class="form-group col-md-2">
        <label for="qtdeDiasUteis" class="mb-1">Qtde de Dias Úteis <br> da Execução</label>
        <input type="number" id="qtdeDiasUteis" class="form-control form-control-sm"
          [value]="model?.osa?.qtdeDiasUteisExecucao" disabled />
      </div>

      <div class="form-group col-md-2">
        <label for="dataInicioRealizacao" class="mb-1">Data Início <br> da Execução</label>
        <input type="text" class="form-control form-control-sm" id="dataInicioRealizacao" [attr.disabled]="true"
          [value]="model?.osa?.dataInicioRealizacao | date: 'dd/MM/yyyy'" disabled />
      </div>

      <div class="form-group col-md-2">
        <label for="dataFimRealizacao" class="mb-1">Data Fim <br> da Execução</label>
        <input type="text" class="form-control form-control-sm" id="dataFimRealizacao" [attr.disabled]="true"
          [value]="model?.osa?.dataFimRealizacao | date: 'dd/MM/yyyy'" />
      </div>

      <div class="form-group col-md-2">
        <label for="dataConstatacoesPreliminares" class="mb-1">Data das Constatações <br> Preliminares</label>
        <input type="text" [attr.disabled]="true" class="form-control form-control-sm"
          [value]="model?.osa?.dataConstatacoesPreliminares | date: 'dd/MM/yyyy'">
      </div>

      <div class="form-group col-md-2">
        <label for="dataApresentacaoRelatorio" class="mb-1">Data para Apresentação <br> do Relatório</label>
        <input type="text" [attr.disabled]="true" class="form-control form-control-sm"
          [value]="model?.osa?.dataApresentacaoRelatorio | date: 'dd/MM/yyyy'">
      </div>
    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="responsavelUg" class="mb-1">Coordenador da Auditoria</label>
        <div class="input-group input-group-sm">
          <input type="text" name="table_search" class="form-control form-control-sm " disabled type="text"
            class="form-control form-control-sm" [value]="model?.osa?.nomeAuditor" />
        </div>
      </div>

      <div class="form-group col-md-6">
        <label for="tipoEnfase" class="mb-1">Tipo de Ênfase</label>
        <input type="text" [readonly]="true" class="form-control form-control-sm"
          [value]="model?.osa?.planejamento?.opa?.tipoEnfase?.nome" />
      </div>

    </div>

    <label>Equipe de Auditores</label>
    <div class="mat-elevation-z4">
      <table mat-table [dataSource]="equipeDataSource" matSort #tabela2="matSort">

        <!-- Coluna Auditor -->
        <ng-container matColumnDef="auditor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Auditor</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.indisponivelPeriodo" style="color: red;"><i class="fas fa-exclamation-triangle"
                title="Auditor indisponível para o período"></i>
              {{ element.nomeAuditor }} </span>
            <span *ngIf="!element.indisponivelPeriodo">
              {{ element.nomeAuditor }} </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <h5 [hidden]="equipeDataSource.data.length > 0" class="table-no-data">
        Nenhum registro encontrado.
      </h5>
      <mat-paginator 
        #TableTwoPaginator="matPaginator" 
        [hidden]="!(equipeDataSource?.data?.length > 0)" 
        [pageSizeOptions]="[5, 10, 15]" 
        showFirstLastButtons
        >
      </mat-paginator>
    </div>

    <label class="mt-4">Selecionar Ugs</label>
    <div class="mat-elevation-z4 mb-4">
      <table mat-table class="w-100" [dataSource]="dataSourceUgSubTipos" matSortDisableClear #tabela1="matSort" matSort
        matSortDirection="asc">

        <ng-container matColumnDef="ug">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Unidade(s) Gestora(s)
          </th>
          <td mat-cell *matCellDef="let element" class="text limit-text">
            {{element?.unidadeGestora?.sigla}} - {{ element?.unidadeGestora?.nome }}
          </td>
        </ng-container>

        <ng-container matColumnDef="subtipo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Subtipo
          </th>
          <td mat-cell *matCellDef="let element" class="text limit-text">
            {{ element?.subtipoAuditoria?.subTipoAuditoria?.nome }}
            {{ element?.subtipoAuditoria?.nome }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusUg">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status UG's </th>
          <td mat-cell *matCellDef="let element">
            {{
              isArray(element.statusUg)
                ? element.statusUg.join(' e ')
                : (element.statusUg || 'Sem status')
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="numeroOsa">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Número OSA
          </th>
          <td mat-cell *matCellDef="let element" class="text limit-text">
            {{ element?.numeroOsa }}
          </td>
        </ng-container>

        <ng-container cdkColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button type="button" class="btn btn-success btn-xs w-100"
            (click)="modalIncluirUg()" *ngIf="!visualizar">
              Adicionar
            </button>
          </th>
          <td mat-cell *matCellDef="let element; let i = index" class="block">
            <div class="d-flex w-100 justify-content-center align-items-center">
              <button type="button" class="btn btn-danger btn-xs text-left " (click)="excluirUg(element.unidadeGestoraId, element.subTipoAuditoriaId)" *ngIf="!visualizar && !element?.numeroOsa"
              >
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsUg" class="bg-light"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsUg"></tr>
      </table>
      <h5 class="table-no-data" [hidden]="dataSourceUgSubTipos?.data?.length > 0">
        Nenhuma Ug vinculada
      </h5>

      <mat-paginator 
        #TableTreePaginator="matPaginator" 
        [hidden]="!(dataSourceUgSubTipos?.data?.length > 0)" 
        [pageSizeOptions]="[5, 10, 15]" 
        showFirstLastButtons
        >
      </mat-paginator>

    </div>
  </div>
</form>